// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SaNSENUFBAy3dSGjr\\+QkGQ\\=\\={margin-bottom:0 !important}", "",{"version":3,"sources":["webpack://./components/Typography/Text/styles.module.scss"],"names":[],"mappings":"AAAA,6BACE,0BAAA","sourcesContent":[".noMargin {\n  margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noMargin": "SaNSENUFBAy3dSGjr+QkGQ=="
};
export default ___CSS_LOADER_EXPORT___;
